import VueRouter, { RouteConfig } from 'vue-router'

const Edit = () => import('../views/school-mgt/Edit.vue')

export const editRoute: RouteConfig = {
  path: '/school-mgt-edit',
  name: 'school_mgt_edit',
  component: Edit,
  props: (route) => ({
    ...route.query,
    ...route.params,
    initialized: 'initialized' in route.query && route.query.initialized !== undefined,
  }),
  meta: {
    title: '更换执教学校',
  },
}

export default [editRoute]

export function navigateToSchoolMgtEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}
